import * as React from "react";
import StatAttribute from "../StatAttribute/StatAttribute";
import {toRoman} from "../../helpers/helpers";

const STRINGS = {
    STOCK: gettext("Stock"),
};

export default class TankComponent extends React.Component {

    render() {
        let LEVEL_CLASS = "tank-config_level";
        let ARROW_CLASS = "tank-config_arrow";

        const componentData = this.props.componentData;
        let level = componentData.level,
            newLevel = componentData.newLevel;
        let currentLevel = level;
        if (newLevel && newLevel !== currentLevel) {
            if (newLevel > level) {
                ARROW_CLASS += " " + ARROW_CLASS + "__up";
                LEVEL_CLASS += " " + LEVEL_CLASS + "__up";
            } else {
                ARROW_CLASS += " " + ARROW_CLASS + "__down";
                LEVEL_CLASS += " " + LEVEL_CLASS + "__down";
            }
            currentLevel = newLevel;
        }
        let module_level = vehicle.unlock_progression[this.props.tank_module][this.props.currentIndex].level;
        let module_name = vehicle.unlock_progression[this.props.tank_module][this.props.currentIndex].name;
        let is_fake_turret = false;
        if (this.props.tank_module == "turrets" ){
            for(let i of ["turrets0", "turrets1", "turrets2", "turrets3"]) {
                if(vehicle.data[i] && vehicle.data[i][module_name]) {
                    is_fake_turret = vehicle.data[i][module_name]["is_fake_turret"];
                }
            }
        }
        let dualBarrel = false;
        Object.keys(vehicle.guns).forEach(gun => {
            if (vehicle.guns[gun]['reload_time']?.length > 1) {
                dualBarrel = true;
            }
        })       

        return (
             <div className="tank-config module_details">
                <div className="tank-config_header">
                    {/*<div className="tank-config_info">*/}
                    {/*    <span className={ARROW_CLASS}>*/}
                    {/*        <span className="svg-icon js-svg-icon"*/}
                    {/*              data-src={ STATIC_URL +"tankopedia/img/svg-icons/double_arrow.svg"}>*/}
                    {/*        </span>*/}
                    {/*    </span>*/}
                    {/*</div>*/}
                    <div className="tank-config_title" dangerouslySetInnerHTML={{__html: componentData.newTitle}}></div>
                </div>
                <div className="tank-config_details module">
                    {
                        Object.keys(componentData.attributes).map(k => {
                            const attribute = componentData.attributes[k];
                            const hideSiegeForDualBarrel = dualBarrel && attribute.siege;
                            return (
                                <>
                                {!hideSiegeForDualBarrel ? <StatAttribute label={attribute.label} unit={attribute.unit}
                                               value={attribute.value} newValue={attribute.newValue} separator={attribute.separator}
                                               reverse={attribute.reverse} key={k} is_fake_turret={is_fake_turret} slug={k}/> : null}
                                </>
                            )
                        })
                    }
                </div>
            </div>
        )
    }
}
